// eslint-disable-next-line no-shadow
export enum CommandType {
  EnablePrpFlag = 0,
  DisablePrpFlag = 1,
  NtpSyncInterval = 2,
  EnableBitfield = 3,
  LightSyncInterval = 4,
  MSend = 5,
  CommandRepeat = 6,
  EventRepeat = 7,
  DataSaverOn = 8,
  DataSaverOff = 9,
  StatusInterval = 10,
  SetCommunicationDelay = 16
}
